import React from 'react';
import { makeStyles } from '@material-ui/core';

import { ReactComponent as Icon } from '#web-components/assets/icons/mail.svg';
import styles from './EmailIcon.styles';

const useStyles = makeStyles(styles, { name: 'EmailIcon' });

export default function EmailIcon() {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <Icon />
    </div>
  );
}
